import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { colors } from "src/assets";
import LocalText from "src/local";

export type NotFoundProps = {};

export const NotFound: React.FC<NotFoundProps> = ({}) => {
  return (
    <View style={styles.container}>
      <View style={styles.icon}>
        <svg width="88" height="84.275" viewBox="0 0 88 84.275">
          <g
            id="シェイプ_14"
            data-name="シェイプ 14"
            transform="translate(-32.281 -785.531)"
            fill="none"
          >
            <path
              d="M76.281,785.531a5.959,5.959,0,0,0-5.665,4.109l-7.672,23.491-24.712.037a5.96,5.96,0,0,0-3.5,10.776L54.7,838.5l-7.6,23.514a5.96,5.96,0,0,0,9.166,6.66l20.015-14.5,20.015,14.5a5.96,5.96,0,0,0,9.166-6.66l-7.6-23.514,19.97-14.556a5.96,5.96,0,0,0-3.5-10.776l-24.712-.037L81.946,789.64a5.959,5.959,0,0,0-5.665-4.109Z"
              stroke="none"
            />
            <path
              d="M 76.28081512451172 791.6201171875 L 67.29807281494141 819.1241455078125 L 62.95265960693359 819.1306762695312 L 38.264892578125 819.0950927734375 L 61.74610900878906 836.2108154296875 L 60.40956878662109 840.345458984375 L 52.74647521972656 863.814208984375 L 76.28078460693359 846.7695922851562 L 79.80016326904297 849.3184814453125 L 99.75307464599609 863.859130859375 L 90.81584167480469 836.2108154296875 L 94.32720184326172 833.6513061523438 L 114.3211975097656 819.1678466796875 L 85.26358032226562 819.1241455078125 L 76.28081512451172 791.6201171875 M 76.28078460693359 785.5308837890625 C 78.859130859375 785.5308837890625 81.14562225341797 787.1888427734375 81.94596862792969 789.639892578125 L 89.61801910400391 813.1306762695312 L 114.3302154541016 813.1678466796875 C 116.9084777832031 813.1724853515625 119.1920394897461 814.8335571289062 119.9888763427734 817.2862548828125 C 120.7854919433594 819.7388305664062 119.9146423339844 822.4246215820312 117.8309631347656 823.9437255859375 L 97.86145782470703 838.4999389648438 L 105.4622192382812 862.013671875 C 106.2551116943359 864.46630859375 105.3805236816406 867.152099609375 103.2941818237305 868.66796875 C 101.2093124389648 870.1836547851562 98.38522338867188 870.1864624023438 96.29576110839844 868.673583984375 L 76.28078460693359 854.1779174804688 L 56.26587677001953 868.673583984375 C 54.17710113525391 870.1859741210938 51.35302734375 870.1840209960938 49.26747131347656 868.66796875 C 47.18111419677734 867.152099609375 46.30651092529297 864.46630859375 47.09940338134766 862.013671875 L 54.700439453125 838.4999389648438 L 34.73065948486328 823.9437255859375 C 32.64701843261719 822.4246215820312 31.77616882324219 819.7388305664062 32.57276153564453 817.2862548828125 C 33.36962127685547 814.8335571289062 35.65290832519531 813.1724853515625 38.23123931884766 813.1678466796875 L 62.94364166259766 813.1306762695312 L 70.61565399169922 789.639892578125 C 71.41602325439453 787.1888427734375 73.70254516601562 785.5308837890625 76.28078460693359 785.5308837890625 Z"
              stroke="none"
              fill="#b6b6b6"
            />
          </g>
        </svg>
      </View>
      <Text style={styles.text}>
        {LocalText.screens.reviewByOffer.notFound.text}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    marginTop: 31,
    color: colors.black,
    fontSize: 16,
    fontWeight: "bold",
  },
  icon: {},
});
